<template>
  <v-dialog 
  :value="value" 
  max-width="1000"
  @input="$emit('input')">
    <v-card class="pb-2">
      <v-card-title class="mb-3">
        <span class="headline">Engagements rate for @{{handle}}</span>
      </v-card-title>
      <v-card-subtitle>
        <span class="subtitle-1">Distrubution by engagement rate for influencers having followers between {{(followersRange.left_number || 0) | abbr}} and {{(followersRange.right_number || 0) | abbr}}</span>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="items"
              items-per-page="50"
              :hide-default-footer="true"
              :no-data-text="'Empty list'"
              class="elevation-1"              
              :key="dataTableKey"
            >
              <template v-slot:[`item.rate`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    <span :class="{'font-weight-bold': item.handle}">{{ item.rate }}</span>
                    <span class="font-weight-bold ml-5" v-if="item.handle">@{{item.handle}}</span>
                    <span class="caption ml-5" v-if="item.median">Median</span>
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    {{item.total | thousandSeprator}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import utils from '../../../utils';
export default {
  name: 'MedianEngagementsModal',
  props: [
    'items',
    'value',
    'handle',
    'engagementRate',
    'followersRange'
  ],
  data() {
    return {
      headers: [
        {
          text: 'Engagements rate range',
          value: 'rate'
        },
        {
          text: 'Influencers',
          value: 'total'
        }
      ],
      items: [],
      dataTableKey: 1
    }
  },
  // watch: {
  //   value: function(newValue) {
  //     this.calculateMedians()
  //   }
  // },
  methods: {
    close() {
      this.$emit('input')
    }
    // calculateMedians() {
    //   this.items = utils.func.refreshJSON(this.medianItems)
    //   this.items = this.items.map(item => {
    //     item.min = item.min ? (Number(item.min) * 100).toFixed(2) : -1
    //     item.max = item.max ? (Number(item.max) * 100).toFixed(2) : -1

    //     if (this.engagementRate >= Number(item.min) && this.engagementRate <= Number(item.max)) {
    //       item.handle = this.handle
    //     }
    //     item.rate = ''
    //     if (item.min === -1 && item.max >= 0) {
    //       item.rate += `< ${item.max}%`
    //     } else if (item.max === -1 && item.min >= 0) {
    //       item.rate += `> ${item.min}%`
    //     } else if (item.max > 0 && item.min >= 0) {
    //       item.rate += `${item.min}% - ${item.max}%`
    //     }
    //     return item
    //   })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// MedianEngagementsModal.vue?b1166c02